import React from 'react';

/**
 * 점검 기록의 본문을 읽을 수 있게 편다.
 *
 * 제출할 때 한 덩어리 글로 저장한다. `- 항목 [보기1, 보기2]` 꼴의 줄은 고른
 * 보기를 항목 아래에 들여 놓아야 무엇에 답한 것인지 보인다.
 */
export const formatDescription = (description) => {
    if (!description) return null;
    return description.split('\n').map((line, idx) => {
        const match = line.match(/^(.*?) \[(.*?)\]$/);
        if (match) {
            const baseText = match[1];
            const options = match[2].split(', ');
            return (
                <div key={idx} className="mb-1">
                    <div>{baseText}</div>
                    {options.map((opt, i) => (
                        <div key={i} className="text-secondary ps-3 small mt-1 d-flex align-items-start">
                            <i className="bi bi-check2 text-success me-2" style={{ fontSize: '1rem', lineHeight: '1.2' }}></i>
                            <span style={{ lineHeight: '1.4' }}>{opt}</span>
                        </div>
                    ))}
                </div>
            );
        }
        return <div key={idx} className={line.trim() === '' ? 'mb-2' : 'mb-1'}>{line}</div>;
    });
};

/**
 * 첫 줄의 「점검 완료: 8/10 항목」 만 뽑는다.
 *
 * 접어 둔 기록의 한 줄 요약으로 쓴다. 없으면 없는 대로 둔다 -- 형식이 바뀐
 * 옛 기록에 억지로 숫자를 지어내는 것보다 낫다.
 */
export const describeCounts = (description) => {
    const m = /^점검 완료: (\d+\/\d+ 항목)/.exec(description || '');
    return m ? m[1] : null;
};
